import { render, staticRenderFns } from "./jcjl.vue?vue&type=template&id=41bf4719&"
import script from "./jcjl.vue?vue&type=script&lang=js&"
export * from "./jcjl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports